import {Trash2, Eye} from 'lucide-react';
import {Store} from '../../models/store.model';

interface StoreTableActionsProps {
  store: Store;
  deletingStoreId?: string | null;
  onViewDetails?: (store: Store) => void;
  onDeleteStore?: (id: string) => void;
}

export const StoreTableActions = ({
  store,
  deletingStoreId,
  onViewDetails,
  onDeleteStore
}: StoreTableActionsProps) => {
  return [
    {
      label: 'عرض التفاصيل',
      icon: <Eye className="text-brand-600" size={20} />,
      onClick: () => onViewDetails?.(store)
    },
    {
      label: deletingStoreId === store.id.toString() ? 'جاري الحذف...' : 'حذف المتجر',
      icon: <Trash2 className="text-red-600" size={20} />,
      onClick: () => onDeleteStore?.(store.id.toString()),
      danger: true
    }
  ];
};
